// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportObjects = {
	1913: function() {
		return {
			"./blessing_skin_shell_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache0["ug"](p0i32);
				},
				"__wbg_write_fe57756566e4d679": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache1["mh"](p0i32,p1i32,p2i32);
				},
				"__wbg_clear_3049b4776b07ab3e": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache2["xI"](p0i32);
				},
				"__wbg_stdio_new": function(p0i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache3["rx"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache4["h4"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache5["m_"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache6["XP"](p0i32);
				},
				"__wbg_instanceof_Window_adf3196bdc02b386": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache7["xo"](p0i32);
				},
				"__wbg_fetch_8fd2e4322bb8dc59": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache8["nJ"](p0i32,p1i32,p2i32);
				},
				"__wbg_instanceof_Response_328c03967a8e8902": function(p0i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache9["EN"](p0i32);
				},
				"__wbg_text_966d07536ca6ccdc": function(p0i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache10["Uu"](p0i32);
				},
				"__wbindgen_cb_drop": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache11["G6"](p0i32);
				},
				"__wbg_new_e13110f81ae347cf": function() {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache12["J"]();
				},
				"__wbg_push_b46eeec52d2b03bb": function(p0i32,p1i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache13["vo"](p0i32,p1i32);
				},
				"__wbg_newnoargs_f3b8a801d5d4b079": function(p0i32,p1i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache14["yN"](p0i32,p1i32);
				},
				"__wbg_call_8e95613cc6524977": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache15["Bs"](p0i32,p1i32);
				},
				"__wbg_call_acb1ec2343d35cab": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache16["Hw"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_resolve_2529512c3bb73938": function(p0i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache17["cJ"](p0i32);
				},
				"__wbg_then_4a7a614abbbe6d81": function(p0i32,p1i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache18["$d"](p0i32,p1i32);
				},
				"__wbg_then_3b7ac098cfda2fa5": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache19["YD"](p0i32,p1i32,p2i32);
				},
				"__wbg_self_07b2f89e82ceb76d": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache20["aZ"]();
				},
				"__wbg_window_ba85d88572adc0dc": function() {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache21["ko"]();
				},
				"__wbg_globalThis_b9277fc37e201fe5": function() {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache22["PG"]();
				},
				"__wbg_global_e16303fe83e1d57f": function() {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache23["PA"]();
				},
				"__wbg_get_0e3f2950cdf758ae": function(p0i32,p1i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache24["O1"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache25["qt"](p0i32,p1i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache26["fY"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache27["Or"](p0i32,p1i32);
				},
				"__wbindgen_closure_wrapper922": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[5810].exports;
					return wasmImportedFuncCache28["tn"](p0i32,p1i32,p2i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"331": [
		1913
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"331":{"1913":"8149fbd145fc29e3ea91"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};